import React, { createContext, useState, useMemo } from "react";

export const yScrollContext = createContext({
  yScroll: 0,
  setYscroll: (prevState: number) => prevState
});

export const YScroll = ({ children }: any) => {
  const [yScroll, setYscroll] = useState(0);
  // fix for react/jsx-no-constructed-context-values
  const value = useMemo(
    () => ({
      yScroll,
      setYscroll
    }),
    [yScroll]
  );

  return (
    <yScrollContext.Provider value={value as any}>
      {children}
    </yScrollContext.Provider>
  );
};
